var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaddarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0F172A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.7,5.2L18,3.9c-0.3-0.5-0.6-0.9-1.1-1.1c-0.5-0.3-1-0.5-1.5-0.5H4.7c-0.5,0-1,0.1-1.5,0.4 C2.7,3,2.3,3.4,2.1,3.9L1.4,5.1l0,0C1.1,5.7,1,6.3,1.3,6.8c0.2,0.5,0.6,0.8,1.1,1v6.9c0,0.8,0.3,1.6,0.9,2.1 c0.6,0.6,1.3,0.9,2.1,0.9h9.3c0.8,0,1.6-0.3,2.1-0.9c0.6-0.6,0.9-1.3,0.9-2.1V7.8c0.4-0.1,0.7-0.4,0.9-0.7l0,0 C18.9,6.6,19,5.9,18.7,5.2z M5.8,13.6c0-0.6,0.5-1.1,1.1-1.1h0.8c0.6,0,1.1,0.5,1.1,1.1v2.9H5.8V13.6z M7.8,11.1H7 c-1.3,0-2.4,1.1-2.4,2.4v2.6c-0.5-0.3-0.9-0.9-0.9-1.5V7.9h12.7v6.7c0,0.9-0.8,1.7-1.7,1.7h-4.4v-2.9C10.2,12.2,9.1,11.1,7.8,11.1z  M17.5,6.4c-0.1,0.1-0.2,0.2-0.4,0.2L3,6.6c-0.2,0-0.4-0.1-0.5-0.2C2.4,6.2,2.4,6,2.5,5.8l0.7-1.3C3.5,4,4,3.6,4.7,3.6h10.7 c0.6,0,1.1,0.3,1.5,0.8l0.7,1.3C17.6,5.9,17.6,6.2,17.5,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,14.6h2.6c0.7,0,1.2-0.6,1.2-1.2v-1.7c0-0.7-0.5-1.2-1.2-1.2H12c-0.7,0-1.2,0.6-1.2,1.2v1.7 C10.8,14.1,11.3,14.6,12,14.6z M12,13.4v-1.6l2.5,0l0,1.6H12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaddarIcon);
export default __webpack_public_path__ + "static/media/saddarIcon.8faa54503e5cacfee379f3ad74125978.svg";
export { ForwardRef as ReactComponent };